qtee.customDesign = window.qtee.customDesign || {};

/**
 * Create and initialize all necessary objects for application
 * @return {Promise}
 */
qtee.customDesign.initApp = function () {

	// register plugins for Canvas Elements Factory
	for (var type in qtee.customDesign.settings.names) {

		qtee.customDesign.elementFactory.addPlugin(type, function (model, paper, opts) {

			return new window[qtee.customDesign.settings.names[model.type].plugin](model, paper, opts);

		});

	}

	qtee.customDesign.canvas = new CustomDesignCanvas();
	qtee.customDesign.canvas.history = [];

	qtee.customDesign.fonts = new DownloadableFonts(qtee.customDesign.settings.fonts);
	qtee.customDesign.availablePatterns = new qtee.customDesign.AvailablePatterns();
	qtee.customDesign.availableColors = new qtee.customDesign.AvailableColors();

	return Promise.resolve();

};
